import { Flag } from 'redux/reducers/moderation/types';

const FLAGS = [0, 2, 4, 8, 16, 32, 64, 128];

export function transformFlagCounts(flag_counts: Record<number, number>) {
  const result: Record<number, number> = {};

  for (const [keyStr, count] of Object.entries(flag_counts)) {
    const key = Number(keyStr);

    if (key === 0) {
      result[0] = (result[0] || 0) + count;
      continue;
    }

    const activeFlags = FLAGS.filter((f) => f !== 0 && (key & f) !== 0);

    for (const flag of activeFlags) {
      result[flag] = (result[flag] || 0) + count;
    }
  }

  return {
    keys: Object.keys(result)
      .map(Number)
      .sort((a, b) => a - b),
    values: Object.values(result),
  };
}

export function getTotalViolations(restrictions: { cnt: number; restriction: number }[] = []) {
  let total = 0;

  for (const { cnt, restriction } of restrictions) {
    if (restriction === 0) continue; // без порушень

    // визначаємо, скільки прапорців активні у цьому restriction
    const activeFlags = FLAGS.filter((f) => f !== 0 && (restriction & f) !== 0);

    // кожен активний прапорець додає стільки ж cnt
    total += cnt * activeFlags.length;
  }

  return total;
}

export function decodeRestriction(restriction: number, allFlags: Flag[]): Flag[] {
  if (!allFlags?.length) return [];

  // беремо лише "чисті" біти (степені двійки) + 0
  const baseFlags = allFlags.filter((f) => f.value === 0 || (f.value & (f.value - 1)) === 0);

  if (restriction === 0) {
    // без порушень — повернемо флаг 0 (якщо є)
    return baseFlags.filter((f) => f.value === 0);
  }

  return baseFlags.filter((f) => f.value !== 0 && (restriction & f.value) !== 0);
}
